module.exports = __webpack_public_path__ + "static/media/paper.39afec64.svg";